import { helper } from '@ember/component/helper';

export const toLowerCase = ([string]) => (string ?? '').toLowerCase();

export default helper(toLowerCase);
